"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var moment_1 = __importDefault(require("moment"));
var lodash_1 = require("lodash");
var dsSearchStudentsController = /** @class */ (function () {
    function dsSearchStudentsController(UsersModel, FlashService) {
        this.students = [];
        this.UsersModel = UsersModel;
        this.FlashService = FlashService;
        this.searchingStudents = false;
        this.drivesession = this.drive;
        if (!this.change) {
            this.change = function () { };
        }
        this.searchStudents = (0, lodash_1.debounce)(this.searchStudents.bind(this), 500);
    }
    /**
     * Search for students by name
     * @param search
     * @param all
     */
    dsSearchStudentsController.prototype.searchStudentsByName = function (search, all) {
        var _this = this;
        var searchParams = {
            name: "",
        };
        this.searchingStudents = false;
        this.FlashService.clearFlash();
        if (search && search.length >= 3 && !this.searchingStudents) {
            searchParams.name = search;
        }
        if (typeof searchParams.name === 'undefined') {
            return;
        }
        this.searchingStudents = true;
        this.UsersModel.searchStudentsByName(searchParams).then(function (response) {
            response.students.filter(function (student) {
                if (student.hasOwnProperty('guardian')) {
                    if (!student.guardian.hasOwnProperty('firstname')) {
                        delete student.guardian;
                    }
                }
                return student;
            });
            _this.students = response.students;
            _this.searchingStudents = false;
        });
    };
    /**
     * Search for students by name/date
     * (THIS FUNCTION IS DECPRECATED, THIS DIRECTIVE IS NO LONGER USED ON THE CREATE SESSION PAGE JUST THE CREATE ORDER PAGE)
     * @param search
     * @param all
     */
    dsSearchStudentsController.prototype.searchStudents = function (search, all) {
        var _this = this;
        var searchParams = {};
        this.searchingStudents = false;
        this.FlashService.clearFlash();
        if (all === false && typeof this.drivesession === 'object') {
            searchParams = {
                'hours': (parseInt(this.drivesession.sessionLengthHours) * 60) + parseInt(this.drivesession.sessionLengthMinutes),
                'date': {
                    'date': (0, moment_1.default)(this.drivesession.drive_date).format('YYYY-MM-DD'),
                    'time': (0, moment_1.default)(this.drivesession.start_time).format('HH:mm:ss'),
                    'duration': (parseInt(this.drivesession.sessionLengthHours) * 60) + parseInt(this.drivesession.sessionLengthMinutes)
                },
                'exclude': {
                    'drives': [{ 'id': this.drivesession.id }]
                }
            };
        }
        if (search && search.length >= 3 && !this.searchingStudents) {
            searchParams.name = search;
        }
        if (typeof searchParams.name === 'undefined') {
            return;
        }
        searchParams.toggleStudentSchoolOverride = this.toggleStudentSchoolOverride;
        this.searchingStudents = true;
        this.UsersModel.searchStudents(searchParams).then(function (response) {
            response.students.filter(function (student) {
                if (student.hasOwnProperty('guardian')) {
                    if (!student.guardian.hasOwnProperty('firstname')) {
                        delete student.guardian;
                    }
                }
                return student;
            });
            _this.students = response.students;
            _this.searchingStudents = false;
        });
    };
    return dsSearchStudentsController;
}());
dsSearchStudentsController.$inject = ['UsersModel', 'FlashService'];
exports.default = dsSearchStudentsController;
